export default {
	install: (Vue, options) => {
		// Setup csrf token
		$.ajaxSetup({
		    headers: {
		        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
		    }
		})
		Vue.prototype.$asyncPost = async (url, data, showError = true) => {
			try {
				return await $.post(url, $.param(data)).promise();
			} catch (e) {
				if (showError) {
					Swal.fire({
				      type: 'error',
				      title: 'Oops...',
				      html: e.responseJSON.message
				    });
				}

				if (e.responseJSON) {
					return e.responseJSON;
				}

				return e;
			}
		}
	}
}
